import { useQuery } from 'data-fetching-client';
import * as t from 'ts-schema';
import { GET_SMART_COPY_PROGRESS } from '../queries';
// #region Schema
const importingStateSchema = t.object({
  importedArticleCount: t.number,
  skippedArticleCount: t.number,
  state: t.literal('IMPORTING'),
  totalArticleCount: t.number
});
const completedStateSchema = t.object({
  autoPublishEnabled: t.boolean,
  importedArticleCount: t.number,
  skippedArticleCount: t.number,
  state: t.literal('COMPLETED'),
  totalArticleCount: t.number
});
const canceledStateSchema = t.object({
  autoPublishEnabled: t.boolean,
  importedArticleCount: t.number,
  state: t.literal('CANCELLED'),
  totalArticleCount: t.number
});
// #endregion

export const useSmartCopyProgress = knowledgeBaseId => {
  const {
    data: {
      smartCopyProgress
    } = {
      smartCopyProgress: undefined
    },
    error,
    previousData,
    startPolling,
    stopPolling
  } = useQuery(GET_SMART_COPY_PROGRESS, {
    variables: {
      knowledgeBaseId
    },
    fetchPolicy: 'network-only'
  });
  if (!smartCopyProgress || error) {
    return {
      state: 'none'
    };
  }
  startPolling(1000);
  if (smartCopyProgress.state === 'INITIALIZED' || smartCopyProgress.state === 'SCRAPING') {
    return {
      state: 'SCRAPING'
    };
  }
  if (smartCopyProgress.state === 'CANCELLING') {
    return {
      state: 'CANCELLING'
    };
  }
  if (smartCopyProgress.state === 'IMPORTING') {
    return t.assert(importingStateSchema, smartCopyProgress);
  }
  if (previousData && previousData.smartCopyProgress.knowledgeBaseId === knowledgeBaseId && previousData.smartCopyProgress.state !== 'COMPLETED' && smartCopyProgress.state === 'COMPLETED') {
    stopPolling();
    return t.assert(completedStateSchema, smartCopyProgress);
  }
  if (previousData && previousData.smartCopyProgress.knowledgeBaseId === knowledgeBaseId && previousData.smartCopyProgress.state !== 'CANCELLED' && smartCopyProgress.state === 'CANCELLED') {
    stopPolling();
    return t.assert(canceledStateSchema, smartCopyProgress);
  }
  stopPolling();
  return {
    state: 'none'
  };
};
export const isInProgress = progress => {
  return progress.state === 'CANCELLING' || progress.state === 'IMPORTING' || progress.state === 'SCRAPING';
};